<script setup lang="ts">
import InformationBaseCardVue from '@/components/Cards/InformationBaseCard.vue'
import DeviceSelector from '@/components/Selector/components/DeviceSelector.vue'
import type { TicketModel } from '@/types/models/TicketModel'
import TypographyItem from '../../../Typography/TypographyItem.vue'

type Props = {
    device?: string
    isInEditMode?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<TicketModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <InformationBaseCardVue :label="$t('ticket.model.device')">
        <TypographyItem v-if="!isInEditMode" :label="device" />
        <DeviceSelector
            v-else
            :label="$t('ticket.model.device')"
            field="serial_number"
            :selectedDevice="device"
            @select="$emit('change', { serial_number_device: $event.serial_number })" />
    </InformationBaseCardVue>
</template>
